<template>
    <div>
        <h1 class="title is-3 between-center">
            <span>Correspondence Filtering</span>
            <div class="field is-grouped">
<!--                 <p v-if="isResetFiltersButtonVisible" class="control">
                    <a @click.prevent="resetFilters" class="button is-default is-small">Reset filters</a>
                </p>
 -->                <p v-if="isDeleteSelectedButtonVisible" class="control">
                <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                </p>
            </div>
        </h1>
        <div class="columns">
            <div class="column">
                <o-table
                    class="is-responsive is-responsive-xs-desktop"
                    :data="emails"
                    :bordered="isBordered"
                    :striped="isStriped"
                    :narrowed="isNarrowed"
                    :checkable="isCheckable"
                    :loading="isLoading"
                    :mobile-cards="hasMobileCards"
                    :paginated="isPaginated"
                    :per-page="perPage"
                    :pagination-simple="isPaginationSimple"
                    default-sort="name"
                    :selected.sync="selected"
                    :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event">

                    <template slot-scope="props">

                        <o-table-column field="from" label="From" sortable>
                            {{ props.row.from }}
                        </o-table-column>

                        <o-table-column field="to" label="To" sortable>
                            {{ props.row.to }}
                        </o-table-column>

                        <o-table-column field="subject" label="Subject" sortable>
                            {{ props.row.subject }}
                        </o-table-column>

                        <o-table-column field="body" label="body" sortable>
                            {{ props.row.body }}
                        </o-table-column>

                        <o-table-column field="project" label="Project" sortable>
                            <router-link v-if="props.row.isAssigned" :to="{ name: 'projects.show', params: { slug: props.row.project } }">
                                {{ props.row.project }}
                            </router-link>
                            <span v-else>Not Assigned</span>
                        </o-table-column>

                        <o-table-column label="">
                            <o-dropdown hoverable position="bottom-left" class="table-actions">
                                <button class="button" slot="trigger">
                                    <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                                </button>
                                <o-dropdown-item has-link><a @click="openProjectsModal(props.row)">Edit</a></o-dropdown-item>
                            </o-dropdown>
                        </o-table-column>

                    </template>

                    <div slot="empty" class="has-text-centered">
                        This table is empty!
                    </div>
                </o-table>
            </div>
        </div>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isProjectsModalActive" has-modal-card>
            <projects-modal :correspondence-prop="currentCorrespondence"/>
        </o-modal>
    </div>
</template>

<script>
    import ProjectsModal from '../../components/modals/Projects'

    export default {
        components: {
            ProjectsModal,
        },

        data() {
            return {
                currentCorrespondence: null,
                isProjectsModalActive: false,
                emails: [
                    {"id": 1, "projectId": null, "project": "", "from": "john@doe.com", "to": "jane@doe.com", "subject": "Subject 1", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit culpa, ullam illo cumque aliquam quis.", "isAssigned": false},
                    {"id": 2, "projectId": 2, "project": "Project Builders", "from": "jimmy@doe.com", "to": "john@doe.com", "subject": "Subject 2", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur esse fuga iste, excepturi, odit omnis libero nisi, dolorem incidunt ea quae praesentium, laudantium dolores eveniet.", "isAssigned": true},
                    {"id": 3, "projectId": 3, "project": "Stamford Tent & Equipment Co", "from": "jane@doe.com", "to": "jimmy@doe.com", "subject": "Subject 3", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit.", "isAssigned": true},
                    {"id": 1, "projectId": null, "project": "", "from": "john@doe.com", "to": "jane@doe.com", "subject": "Subject 1", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit culpa, ullam illo cumque aliquam quis.", "isAssigned": false},
                    {"id": 2, "projectId": 2, "project": "Project Builders", "from": "jimmy@doe.com", "to": "john@doe.com", "subject": "Subject 2", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur esse fuga iste, excepturi, odit omnis libero nisi, dolorem incidunt ea quae praesentium, laudantium dolores eveniet.", "isAssigned": true},
                    {"id": 3, "projectId": 3, "project": "Stamford Tent & Equipment Co", "from": "jane@doe.com", "to": "jimmy@doe.com", "subject": "Subject 3", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit.", "isAssigned": true},
                    {"id": 1, "projectId": null, "project": "", "from": "john@doe.com", "to": "jane@doe.com", "subject": "Subject 1", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit culpa, ullam illo cumque aliquam quis.", "isAssigned": false},
                    {"id": 2, "projectId": 2, "project": "Project Builders", "from": "jimmy@doe.com", "to": "john@doe.com", "subject": "Subject 2", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur esse fuga iste, excepturi, odit omnis libero nisi, dolorem incidunt ea quae praesentium, laudantium dolores eveniet.", "isAssigned": true},
                    {"id": 3, "projectId": 3, "project": "Stamford Tent & Equipment Co", "from": "jane@doe.com", "to": "jimmy@doe.com", "subject": "Subject 3", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit.", "isAssigned": true},
                    {"id": 1, "projectId": null, "project": "", "from": "john@doe.com", "to": "jane@doe.com", "subject": "Subject 1", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit culpa, ullam illo cumque aliquam quis.", "isAssigned": false},
                    {"id": 2, "projectId": 2, "project": "Project Builders", "from": "jimmy@doe.com", "to": "john@doe.com", "subject": "Subject 2", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur esse fuga iste, excepturi, odit omnis libero nisi, dolorem incidunt ea quae praesentium, laudantium dolores eveniet.", "isAssigned": true},
                    {"id": 3, "projectId": 3, "project": "Stamford Tent & Equipment Co", "from": "jane@doe.com", "to": "jimmy@doe.com", "subject": "Subject 3", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit.", "isAssigned": true},
                    {"id": 1, "projectId": null, "project": "", "from": "john@doe.com", "to": "jane@doe.com", "subject": "Subject 1", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit culpa, ullam illo cumque aliquam quis.", "isAssigned": false},
                    {"id": 2, "projectId": 2, "project": "Project Builders", "from": "jimmy@doe.com", "to": "john@doe.com", "subject": "Subject 2", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur esse fuga iste, excepturi, odit omnis libero nisi, dolorem incidunt ea quae praesentium, laudantium dolores eveniet.", "isAssigned": true},
                    {"id": 3, "projectId": 3, "project": "Stamford Tent & Equipment Co", "from": "jane@doe.com", "to": "jimmy@doe.com", "subject": "Subject 3", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit.", "isAssigned": true},
                    {"id": 1, "projectId": null, "project": "", "from": "john@doe.com", "to": "jane@doe.com", "subject": "Subject 1", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit culpa, ullam illo cumque aliquam quis.", "isAssigned": false},
                    {"id": 2, "projectId": 2, "project": "Project Builders", "from": "jimmy@doe.com", "to": "john@doe.com", "subject": "Subject 2", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur esse fuga iste, excepturi, odit omnis libero nisi, dolorem incidunt ea quae praesentium, laudantium dolores eveniet.", "isAssigned": true},
                    {"id": 3, "projectId": 3, "project": "Stamford Tent & Equipment Co", "from": "jane@doe.com", "to": "jimmy@doe.com", "subject": "Subject 3", "body": "Lorem ipsum dolor sit amet, consectetur adipisicing elit.", "isAssigned": true},
                ],
                checkedRows: [],
                selected: {},
                isBordered: false,
                isStriped: true,
                isNarrowed: false,
                isCheckable: true,
                isLoading: false,
                hasMobileCards: true,
                isPaginated: true,
                isPaginationSimple: false,
                perPage: 10,
            }
        },

        methods: {
            openProjectsModal(correspondence) {
                this.currentCorrespondence = correspondence
                this.isProjectsModalActive = true
            },
            clearSelected() {
                this.selected = {}
            },
            clearCheckedRows() {
                this.checkedRows = []
            },
            confirmCustomDelete() {
                this.$swal.fire({
                    title: 'Deleting email',
                    text: 'Are you sure you want to <strong>delete</strong> this email? This action cannot be undone.',
                    confirmText: 'Delete Email',
                    icon: 'error',
                    hasIcon: true,
                    onConfirm: () => {
                        this.$swal.fire('Email deleted!')
                    }
                })
            }
        },

        computed: {
            isDeleteSelectedButtonVisible () {
                return this.checkedRows.length
            },
        }
    }
</script>